/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Hubs_Signals_Ai_Point_HonestyInputs */

const en_directory_hubs_signals_ai_point_honesty = /** @type {(inputs: Directory_Hubs_Signals_Ai_Point_HonestyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The benchmark is conservative on purpose: undocumented or beta-gated interfaces score zero until they are publicly usable.`)
};

const zh_directory_hubs_signals_ai_point_honesty = /** @type {(inputs: Directory_Hubs_Signals_Ai_Point_HonestyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`基准刻意保守：未文档化或仅内测可用的接口在公开可用之前一律零分。`)
};

/**
* | output |
* | --- |
* | "The benchmark is conservative on purpose: undocumented or beta-gated interfaces score zero until they are publicly usable." |
*
* @param {Directory_Hubs_Signals_Ai_Point_HonestyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_hubs_signals_ai_point_honesty = /** @type {((inputs?: Directory_Hubs_Signals_Ai_Point_HonestyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Hubs_Signals_Ai_Point_HonestyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_hubs_signals_ai_point_honesty(inputs)
	return zh_directory_hubs_signals_ai_point_honesty(inputs)
});
export { directory_hubs_signals_ai_point_honesty as "directory.hubs.signals.ai.point.honesty" }